function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React from 'react';
import classNames from 'classnames';
import CardSkeletonBone from '../card-skeleton-bone';
import style from './styles.module.scss';

var CardSkeletonLoader = function CardSkeletonLoader(_ref) {
  var _ref$cardCount = _ref.cardCount,
      cardCount = _ref$cardCount === void 0 ? 4 : _ref$cardCount,
      isLoading = _ref.isLoading,
      descriptorLineCount = _ref.descriptorLineCount,
      children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
  if (!isLoading) return children;

  var bones = _toConsumableArray(new Array(cardCount));

  var mergedClassNames = classNames(className, style.loader);
  return /*#__PURE__*/React.createElement("div", {
    className: mergedClassNames
  }, bones.map(function (item, index) {
    return /*#__PURE__*/React.createElement(CardSkeletonBone, {
      key: index,
      descriptorLineCount: descriptorLineCount
    });
  }));
};

export default CardSkeletonLoader;